/* **************************************************** Finishing Shedule Location */
export interface FSLocation {
    id: number;
    category: string;
    sub_category: string | null;
    location_name: string;
    created_by: number | null;
}

export const mapFSLocation = (data: any): FSLocation => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSLocation = {
        id: data.id,
        category: data.category,
        sub_category: data.sub_category || null,
        location_name: data.location_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSLocations = (data: any[]): FSLocation[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSLocation);
};
